import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/movimentacao')({
  component: MovimentacaoLayout,
});

function MovimentacaoLayout() {
  return <Outlet />;
}
